export default __webpack_public_path__ + "static/media/about_background1.cd250b89.png";